class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', async (event) => {
      event.preventDefault();

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

       //console.log("🚨 REMOVE gomb megnyomva! 🚨");
      
        await cartItems.updateQuantity(this.dataset.index, 0, "remove");

         await cartItems.updateCart();

        await cartItems.removeFreeProduct();

      //document.dispatchEvent(new CustomEvent('cart:updated'));
    });
    
    
  }

}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const cartDrawer = document.getElementById("CartDrawer");
    this.depositFeeVariantId = cartDrawer.dataset.depositFeeVariantId; 
    this.freeProductSettings = window.themeSettings || {};
    this.freeProductVariantId = parseInt(this.freeProductSettings.cart_free_product_variant_id);

    this.cartItems = this.initializeCartData();

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
     // document.dispatchEvent(new CustomEvent('cart:updated'));
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

  }

 async onChange(event) {
   await this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
     if(this.bottleItems.length > 0 && this.depositFeeItemIndex !== -1){
       //console.log("Lefut az update cart az onchanged-ben");
    
         //await this.updateCart();
     }
    if(document.activeElement.getAttribute('name') === "minus"){
     await this.removeFreeProduct();
   }
   
  }

   async initializeCartData() {
    //console.log("🔄 Kosár adatok inicializálása...");
     await this.fetchAndSetCart();
     this.refreshBottleCounts();  
     await this.updateCart();

     await this.addFreeProduct();
    //console.log("✅ Kosár adatok elérhetők! Üveges termékek:", this.bottleItems.length);
   // console.log("✅ Kosár adatok elérhetők! Deposit Fee Index", this.depositFeeItemIndex);
     // console.log("✅ Kosár adatok elérhetők! Összes üveges termék darabszám", this.totalBottleItemsCount);
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

async fetchAndSetCart() {
  try {
  const response = await fetch(window.Shopify.routes.root + 'cart.js');
  const cart      = await response.json();
  this.cartTotalPrice = cart.total_price;
  this.cartItems  = cart.items || [];

    } catch (error) {
   // console.error("Hiba a kosár lekérdezésekor:", error);
    return [];
  }
}
  
  refreshBottleCounts() {
  this.bottleItems = this.cartItems.filter(i => i.product_type.includes('uveges'));
  this.depositFeeItemIndex = this.cartItems.findIndex(i => i.product_type.includes('deposit_fee'));
  const defaultUnits = 1;
  this.totalBottleItemsCount = this.bottleItems.reduce((sum, item) => {
      const unitsPerProduct = Number(item.properties?._unit_count) || defaultUnits;
      return sum + item.quantity * unitsPerProduct;
  }, 0);
}

  async updateCart(){
     //console.log("Update Cart lefutott....");
      //await this.fetchAndSetCart();
    const desiredQty = this.totalBottleItemsCount; 
    const currentQty = this.depositFeeItemIndex !== -1
    ? this.cartItems[this.depositFeeItemIndex].quantity
    : 0;
    
      if(desiredQty != currentQty){
       await this.updateQuantity(this.depositFeeItemIndex + 1, this.totalBottleItemsCount);
      }

  }

async addFreeProduct() {
  try {
    await this.fetchAndSetCart();

    const threshold = parseInt(this.freeProductSettings.cart_free_product_price_threshold) * 100;
    const isActive = this.freeProductSettings.default_free_product_enabled_in_cart;
    const allowMultipleFree = this.freeProductSettings.cart_free_product_allow_multiple;
    const freeProductExists = this.cartItems.some(item => item.variant_id === this.freeProductVariantId);
    
    if (!isActive || !this.freeProductVariantId || !threshold) return;

    const freeProductIndex = this.cartItems.findIndex(item => item.variant_id === this.freeProductVariantId);
    const hasFreeProduct = freeProductIndex !== -1;
    const currentQty = hasFreeProduct ? this.cartItems[freeProductIndex].quantity : 0;
    const desiredQty = this.cartTotalPrice >= threshold
      ? (allowMultipleFree ? Math.floor(this.cartTotalPrice / threshold) : 1)
      : 0;


   if (desiredQty > 0 && !hasFreeProduct) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.freeProductVariantId, quantity: desiredQty })
      });

    await this.updateCartItemByVariantId(this.freeProductVariantId, desiredQty);
      return;                  
    }

    if (hasFreeProduct && currentQty !== desiredQty) {
      await this.updateQuantity(freeProductIndex + 1, desiredQty); 
      return;
    }

  } catch (error) {
    console.error("🛑 Hiba az ajándék termék hozzáadása közben:", error);
  }
}


  
 async removeFreeProduct() {
  try {
    await this.fetchAndSetCart();

    const threshold = parseInt(this.freeProductSettings.cart_free_product_price_threshold) * 100;
    const allowMultipleFree = this.freeProductSettings.cart_free_product_allow_multiple;
    const desiredQty = this.cartTotalPrice >= threshold
      ? (allowMultipleFree ? Math.floor(this.cartTotalPrice / threshold) : 1)
      : 0;
    
    const item = this.cartItems.find(i => i.variant_id === this.freeProductVariantId);
    if (!item) {
     // console.warn("❗️ Az ajándék termék nincs a kosárban.");
      return;
    }

    const currentQty = item.quantity;

    if (currentQty !== desiredQty) {
      await this.updateCartItemByVariantId(this.freeProductVariantId, desiredQty);
    }

    //console.log("✅ Ajándék termék eltávolítva és DOM frissítve.");

  } catch (error) {
    console.error("🛑 Hiba az ajándék termék eltávolítása közben:", error);
  }
}

 async updateCartItemByVariantId(variantId, quantity) {
  try {
    await this.fetchAndSetCart();

    const item = this.cartItems.find(i => i.variant_id === variantId);
    if (!item) {
      //console.warn("❗️ Termék nincs a kosárban:", variantId);
      return;
    }

    const body = JSON.stringify({
      id: item.key,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    const response = await fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body
    });

    if (!response.ok) {
      throw new Error(`❌ Szerverhiba: ${response.status}`);
    }

    const state = await response.text();
    const parsedState = JSON.parse(state);

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });

    //console.log("✅ Kosár módosítva:", { variantId, quantity });

  } catch (error) {
    console.error("🛑 Hiba történt a kosár frissítésekor:", error);
  }
}




  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }


  async updateQuantity(line, quantity,name) {
    this.enableLoading(line);
     // console.log(`🛒 updateQuantity() meghívva - Line: ${line}, Mennyiség: ${quantity}, Termék neve: ${name}`);

    const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
    });

    try {
        const response = await fetch(`${routes.cart_change_url}`, { 
            ...fetchConfig(), 
            ...{ body } 
        });
        const state = await response.text();
        const parsedState = JSON.parse(state);

       this.cartItems = parsedState.items;
     
      this.refreshBottleCounts();  
        // console.log("🛍️ Kosár állapot frissült:", parsedState);
      
        this.classList.toggle("is-empty", parsedState.item_count === 0);
       const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

       if (cartFooter) {
            cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        }
        if (cartDrawerWrapper) {
            cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);
        }

       this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
                document.getElementById(section.id)?.querySelector(section.selector) ||
                document.getElementById(section.id);
            if (elementToReplace) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                );
            }
        });
      
       if (document.querySelector('[aria-live="polite"]')) {
            this.updateLiveRegions(line, parsedState.item_count);
        } else {
          //  console.warn("updateLiveRegions kihagyva, mert nincs live region a DOM-ban.");
        }

      const lineItem =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`);
        
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              const focusableElement = lineItem.querySelector(`[name="${name}"]`);
              if (focusableElement) {
                  cartDrawerWrapper
                      ? trapFocus(cartDrawerWrapper, focusableElement)
                      : focusableElement.focus();
              }
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              const emptyCartMessage = cartDrawerWrapper.querySelector(".drawer__inner-empty");
              const focusableLink = cartDrawerWrapper.querySelector("a");
          
              if (emptyCartMessage && focusableLink) {
                  trapFocus(emptyCartMessage, focusableLink);
              }
          } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          const focusElement = document.querySelector(".cart-item__name");
            if(focusElement){
              trapFocus(
                cartDrawerWrapper,
               focusElement
            );
            }
        }
      
        //console.log("Végzett az updateQuantity fetch....");
        this.disableLoading();
  
    } catch (error) {
     //  console.error("Error in updateQuantity:", error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
            overlay.classList.add("hidden")
        );
        const errors =
            document.getElementById("cart-errors") ||
            document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
        throw error;
    }
}

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
    //  console.log("UpdateLiveRegions currentItemCount === itemCount");
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      if (lineItemError && quantityElement) { 
            const errorText = lineItemError.querySelector('.cart-item__error-text');
            if (errorText) {  
                errorText.innerHTML = window.cartStrings.quantityError.replace(
                    '[quantity]',
                    quantityElement.value
                );
            }
        } else {
         //   console.warn("Nem található lineItemError vagy quantityElement az updateLiveRegions() futtatásakor.");
        }
    }

    this.currentItemCount = itemCount;
    
   if (this.lineItemStatusElement) { 
        this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
   if (cartStatus) { 
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    } else {
       // console.warn("cartStatus nem található az updateLiveRegions futtatásakor.");
    }
   
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
